export const mapboxGlyphs = 'mapbox://fonts/mapbox/{fontstack}/{range}.pbf';
